import React from "react";
import ServicePageShell from "../ui/ServicePageShell";
import { ServiceTag } from "../ui/ServiceTag";
import { PrimaryLink } from "../ui/Buttons";
import CallButton from "../ui/CallButton";
import DirectionsButton from "../ui/DirectionsButton";
import BusinessHours from "../ui/BusinessHours";
import ReviewSection from "../ui/ReviewSection";
import SeoHead from "../seo/SeoHead";
import PageBreadcrumb from "../seo/PageBreadcrumb";
import Oil from "../../assets/OilChange.jpg";

const OilChange = () => {
  return (
    <>
      <SeoHead
        title="Oil Change Service in Temecula | Advanced Automotive Smog"
        description="Professional oil change service in Temecula using quality oil and filters for all makes and models. Fast, thorough service that helps protect your engine."
        path="/services/oil-change"
      />
      <ServicePageShell>
        <PageBreadcrumb
          label="Oil Change Service"
          path="/services/oil-change"
          description="Professional oil change service in Temecula using quality oil and filters for all makes and models."
          serviceType="Oil change"
        />

        <div className="flex flex-col gap-10 md:flex-row md:items-center md:gap-14">

          {/* Image - mobile priority */}
          <div className="w-full md:w-1/2 flex justify-center order-1 md:order-none">
            <div className="relative w-full max-w-xs sm:max-w-sm">
              <div className="absolute -inset-3 rounded-3xl bg-teal-600/10 blur-xl" />
              <img
                src={Oil}
                alt="Oil change service"
                className="relative w-full h-auto rounded-3xl border border-slate-200 object-cover shadow-xl"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="w-full md:w-1/2">

            <ServiceTag>Engine maintenance</ServiceTag>

            <h1 className="mb-3 text-2xl font-semibold tracking-tight text-navy-900 sm:text-3xl md:text-4xl">
              Oil Change Service
            </h1>

            <p className="mb-6 text-sm leading-relaxed text-slate-700 sm:text-base">
              Fresh oil keeps your engine protected, cool, and running at peak
              performance. Our oil change service is fast, clean, and done with
              high-quality oil and filters that meet or exceed manufacturer
              standards.
            </p>

            <h2 className="text-lg sm:text-xl font-semibold text-teal-600 mb-2">
              What Is an Oil Change?
            </h2>

            <p className="mb-5 text-sm leading-relaxed text-slate-700 sm:text-base">
              Engine oil breaks down over time due to heat, friction, and
              contaminants. Regular oil changes help your engine stay clean and
              reduce wear on internal components.
              <br />
              <br />
              Our service includes draining old oil, replacing the filter,
              and filling your engine with the correct premium-grade oil for
              smooth, long-lasting performance.
            </p>

            <ul className="space-y-2.5 text-sm text-slate-700 sm:text-base">
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>High-quality oil for better engine protection</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Oil filter replacement included</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Compatible with all makes and models</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Improves engine longevity and reliability</span>
              </li>
              
              <li className="flex items-start gap-2">
                <span className="mt-1 h-1.5 w-1.5 rounded-full bg-teal-600" />
                <span>Service completed quickly and professionally</span>
              </li>
            </ul>

            <div className="mt-8 flex justify-center">
              <PrimaryLink to="/contact" className="px-10 py-3 text-base">
                Book appointment
              </PrimaryLink>
            </div>

          </div>
        </div>

        <div className="mt-14 space-y-10 border-t border-slate-200 pt-12">
          <BusinessHours tone="light" />
          <ReviewSection tone="light" />
          <div className="flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:justify-center">
            <CallButton className="px-8 py-3 text-base" />
            <DirectionsButton className="px-8 py-3 text-base" />
          </div>
        </div>

    </ServicePageShell>
    </>
  );
};

export default OilChange;
